export const isMobileWebkit = () => {
	return CSS.supports('-webkit-touch-callout: none');
};
